import getBreakpoint from "selectors/breakpoint/getBreakpoint";
import isLandscape from "utils/Orientation";
import { createSelector } from "reselect";
import getCssValueFromDefinition from "utils/getCssValueFromDefinition";
import getInitialLoadComplete from "selectors/device/getInitialLoadComplete";

const getViewportHeight = (state) => state.viewport.dimensions.height;
const getViewportWidth = (state) => state.viewport.dimensions.width;

const getChapterButtonSize = createSelector(
  [getBreakpoint, getInitialLoadComplete, getViewportHeight, getViewportWidth],
  (
    breakpoint,
    // `initialLoadComplete` is unused but is necessary to force the selector to recalculate
    //eslint-disable-next-line no-unused-vars
    initialLoadComplete,
    // `viewportHeight` is unused but is necessary to force the selector to recalculate
    viewportHeight,
    // `viewportWidth` is unused but is necessary to force the selector to recalculate
    viewportWidth,
  ) => {
    const breakpointName = breakpoint.breakpoint;
    const landscape = isLandscape({
      height: viewportHeight,
      width: viewportWidth,
    });

    const result = getCssValueFromDefinition({
      breakpoint: breakpointName,
      cssKey: "height",
      landscape,
      property: "chapter-button-size",
    });

    return result;
  },
);

export default getChapterButtonSize;
